export const ECOMETRI_PLUS_DEFAULT_URL = 'https://zenith-catch.lovable.app';

export const getEcometriPlusEmbedUrl = () =>
    process.env.REACT_APP_ECOMETRI_PLUS_URL?.trim() || ECOMETRI_PLUS_DEFAULT_URL;
